<template>
  <div class="master-container">
    <v-content>
      <v-card flat class="mx-3 mt-2 pa-2">
        <v-card-title>ユーザーアカウント情報変更</v-card-title>
        <v-list-item-subtitle><strong class="red--text text--lighten-1">*</strong>：必須項目</v-list-item-subtitle>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-text-field
            v-model="formData.user_cd"
            label="ユーザーID"
            readonly
            disabled
          ></v-text-field>
          <v-text-field
            v-model="formData.user_nm"
            :rules="mainRules"
            required
          >
            <template v-slot:label>
              氏名<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-text-field
            v-model="formData.user_knm"
            :rules="kanaRules"
            required
          >
            <template v-slot:label>
              氏名カナ<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-text-field
            v-model="formData.user_pwd"
            :rules="pwdRules"
            label="新規パスワード"
            :type="'password'"
            placeholder='変更時のみ入力 (半角英数字、#$+-./:=?@[]^_`|のみ使用可)'
            required
          >
          </v-text-field>
          <v-text-field
            v-model="formData.user_pwd2"
            label="新規パスワード再入力"
            :type="'password'"
            :rules="pwd2Rules"
            placeholder='変更時のみ入力 (半角英数字、#$+-./:=?@[]^_`|のみ使用可)'
            required
          >
          </v-text-field>
          <v-text-field
            label="メールアドレス"
            v-model="formData.mladdrs_desc"
            :rules="emailRules"
            required
          >
          </v-text-field>
          <v-text-field
            readonly
            disabled
            v-model="formData.kngn_nm"
            required
          >
            <template v-slot:label>
              権限<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-text-field
            readonly
            disabled
            v-model="formData.kiyk_nm"
            required
          >
            <template v-slot:label>
              監視対象<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-btn width="120" color="indigo lighten-5" depressed to='/initial'>キャンセル</v-btn>
          <div class="float-right">
            <v-dialog v-model="updateDialog" max-width="350">
              <template v-slot:activator="{ on, attrs }">
                <v-btn width="120" dark color="indigo" v-bind="attrs" v-on="on" @click="validate">更新</v-btn>
              </template>
              <v-card v-if="errorFlg">
                <v-card-title class="headline indigo lighten-4" primary-title>更新確認</v-card-title>
                <v-card-text>
                  <v-container>
                    <span style="white-space:pre-wrap;">{{errorMsg}}</span>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="indigo" text @click="updateDialog = false">OK</v-btn>
                </v-card-actions>
              </v-card>
              <v-card v-else>
                <v-card-title class="headline indigo lighten-4" primary-title>更新確認</v-card-title>
                <v-card-text class="pa-2">
                  ユーザー情報を更新します。よろしいですか?
                  <br>{{pwdErrMsg}}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-text class="pa-2">
                  ユーザー名:{{formData.user_nm}}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="indigo" @click="updateDialog = false">キャンセル</v-btn>
                  <v-btn dark color="indigo" @click="submit_update()">更新</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-form>
      </v-card>
    </v-content>
  </div>
</template>

<script>
// import MstrNvgtonDrwr from '../../modules/MstrNvgtonDrwr'
import myAxios from '../../axios/myAxios'
import MsgList from './MsgList'

export default {
  components: {
    // , MstrNvgtonDrwr
  },
  data () {
    return {
      mainRules: [
        v => !!v || '入力は必須です',
        v => (v || '').search(' ') !== 0 || '最初に空欄を入れることは禁止です',
        v => (v || '').search('　') !== 0 || '最初に空欄を入れることは禁止です',
        v => v.length <= 100 || '100文字以内で入力してください'
      ],
      kanaRules: [
        v => !!v || '入力は必須です',
        v => (v || '').search(' ') !== 0 || '最初に空欄を入れることは禁止です',
        v => (v || '').search('　') !== 0 || '最初に空欄を入れることは禁止です',
        v => v.length <= 100 || '100文字以内で入力してください',
        v => (v || '').match(/^[ァ-ヶ ー]*$/) || 'カナで入力してください'
      ],
      pwdRules: [
        v => (v === '' || v.indexOf(' ') < 0) || '半角英数字および#$+-./:=?@[]^_`|で入力してください',
        v => (v === '' || v.indexOf('%') < 0) || '半角英数字および#$+-./:=?@[]^_`|で入力してください',
        v => (v === '' || (v || '').match(/^[A-Za-z0-9#$+-./:=?@[\]^_`|]*$/)) || '半角英数字および#$+-./:=?@[]^_`|で入力してください',
        v => (v === '' || v.length <= 30) || '8文字以上30文字以内で入力してください',
        v => (v === '' || v.length >= 8) || '8文字以上30文字以内で入力してください',
        v => (v === '' || (v || '').match(/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[#$+-./:=?@[\]^_`|])([A-Za-z0-9#$+-./:=?@[\]^_`|]{8,30})$/)) || '半角英大文字、小文字、数字、使用可能な記号( #$+-./:=?@[]^_`| )からそれぞれ1文字以上使用する必要があります'
      ],
      pwd2Rules: [
        v => (v === '' || v === this.formData.user_pwd) || 'パスワードと一致しません'
      ],
      Rules100: [
        v => (v == null || v.length <= 100) || '100文字以内で入力してください'
      ],
      emailRules: [
        v => (v === '' || /.+@.+\..+/.test(v)) || 'メールアドレスの形式で入力してください'
      ],
      updateDialog: false,
      userInfo: false,
      userNameIsValid: true,
      userKanaNameIsValid: true,
      blankIsValid: true,
      userPwdIsValid: true,
      userPwd2IsValid: true,
      mladdrsIsValid: true,
      isChange: false,
      pwdErrMsg: MsgList.MSG_COM_0001,
      pwd2ErrMsg: MsgList.MSG_COM_0001,
      MSG_COM_0001: MsgList.MSG_COM_0001,
      MSG_E002_0001: MsgList.MSG_E002_0001,
      MSG_E002_0002: MsgList.MSG_E002_0002,
      MSG_E002_0003: MsgList.MSG_E002_0003,
      MSG_E002_0004: MsgList.MSG_E002_0004,
      errorFlg: false,
      errorMissMsg: '入力内容に間違いがあります。',
      errorMsg: '',
      user: {
        kngn_typ: null,
        kiyk_cd: null
      },
      formData: {
        user_cd: '',
        user_nm: '',
        user_knm: '',
        user_pwd: '',
        user_pwd2: '',
        mladdrs_desc: '',
        kngn_nm: '',
        kiyk_nm: ''
      },
      mainMenuFlg: false
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isChange) {
      const dialog = window.confirm(MsgList.MSG_CREATE_FORM_LEAVE)
      if (dialog) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  created () {
    // ログインセッションを確認する
    myAxios.get('/api/common/session_manager', {type: 'isLogin'}).then(res => {
      const status = res.data.status
      const result = res.data.result
      // ログインセッションを確認できなければログイン画面に遷移する
      if (!(status && result)) {
        alert(MsgList.MSG_SES_CANNOT_CONFIRM)
        this.$router.push('/')
        this.$store.dispatch('appSetting/fLogin')
      } else {
        this.$store.dispatch('appSetting/tLogin')
        // ユーザの詳細情報を取得する
        myAxios.get('api/usr_mstr/user_my_data').then(res => {
          this.formData.user_cd = res.data[0].user_cd
          this.formData.user_nm = res.data[0].tntsh_nm
          this.formData.user_knm = res.data[0].tntsh_knm
          this.formData.mladdrs_desc = res.data[0].mladdrs_desc
          this.formData.kngn_nm = res.data[0].kngn_nm
          this.formData.kiyk_nm = res.data[1]
        })
        this.$store.dispatch('appSetting/resetId')
        // フットパスの設定
        myAxios.get('/api/common/session_manager', {type: 'kiyk_single_flg'}).then(res => {
          const status = res.data.status
          const result = res.data.result

          if (status) {
            this.mainMenuFlg = !result
          }
        })
      }
    })
  },
  methods: {
    // 氏名入力チェック
    checkName () {
      // ブランクチェック
      if (!this.formData.user_nm) {
        this.userNameIsValid = false
        this.blankIsValid = false
      // 空文字チェック
      } else if (this.formData.user_nm.search('　') === 0) {
        this.userNameIsValid = false
      } else if (this.formData.user_nm.search(' ') === 0) {
        this.userNameIsValid = false
      } else {
        this.userNameIsValid = true
      }
    },
    // 氏名カナ入力チェック
    checkKanaName () {
      // ブランクチェック
      if (!this.formData.user_nm) {
        this.userKanaNameIsValid = false
        this.blankIsValid = false
      // 空文字チェック
      } else if (this.formData.user_knm.search('　') === 0) {
        this.userKanaNameIsValid = false
      } else if (this.formData.user_knm.search(' ') === 0) {
        this.userKanaNameIsValid = false
      // カナを含むかチェック
      } else if (!(this.formData.user_knm).match(/^[ァ-ヶ ー]*$/)) {
        this.userKanaNameIsValid = false
      } else {
        this.userKanaNameIsValid = true
      }
    },
    // メールアドレス入力チェック
    checkEmailAddr () {
      if (!this.formData.mladdrs_desc || this.formData.mladdrs_desc === '') {
        this.mladdrsIsValid = true
      } else if (!/.+@.+\..+/.test(this.formData.mladdrs_desc)) {
        this.mladdrsIsValid = false
      } else {
        this.mladdrsIsValid = true
      }
    },
    // Passwordの入力チェック
    checkPwd () {
      // 入力値がブランクかどうか
      if (!this.formData.user_pwd || this.formData.user_pwd === '') {
        this.formData.user_pwd = ''
        this.pwdErrMsg = ''
        this.userPwdIsValid = true
      // 8文字以上30文字以内かどうか
      } else if (this.formData.user_pwd.length < 8 || this.formData.user_pwd.length > 30) {
        this.userPwdIsValid = false
        this.pwdErrMsg = this.MSG_E002_0001
      // 半角英数字および#$+-./:=?@[]^_`|以外の文字列かどうか
      } else if (!this.formData.user_pwd.match(/^[A-Za-z0-9#$+-./:=?@[\]^_`|]*$/)) {
        this.userPwdIsValid = false
        this.pwdErrMsg = this.MSG_E002_0003
      } else if (this.formData.user_pwd.indexOf(' ') > 0) {
        this.userPwdIsValid = false
        this.pwdErrMsg = this.MSG_E002_0003
      // 半角英数字および#$+-./:=?@[]^_`|がそれぞれ1文字以上入力されていないかどうか
      } else if (!this.formData.user_pwd.match(/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[#$+-./:=?@[\]^_`|])([A-Za-z0-9#$+-./:=?@[\]^_`|]{8,30})$/)) {
        this.userPwdIsValid = false
        this.pwdErrMsg = this.MSG_E002_0004
      } else if (this.formData.user_pwd !== this.formData.user_pwd2) {
        this.userPwdIsValid = false
      } else {
        this.userPwdIsValid = true
        this.pwdErrMsg = 'パスワードが更新されます。'
      }
    },
    // Password再入力の入力チェック
    checkPwd2 () {
      // PasswordとPassword再入力が一致しているかどうか
      if (this.formData.user_pwd !== this.formData.user_pwd2) {
        this.userPwd2IsValid = false
        this.pwd2ErrMsg = this.MSG_E002_0002
      } else {
        this.userPwd2IsValid = true
      }
    },
    // エラーメッセージを作成する
    makeErrorMsg () {
      this.errorMsg = ''
      // blankエラー
      if (!this.blankIsValid) {
        this.errorMsg = MsgList.MSG_FORM_INVALID
      }
      // 入力間違いエラー
      this.errorMsg = this.errorMsg + '\n' + this.errorMissMsg
      this.blankIsValid = true
    },
    validate () {
      this.checkName()
      this.checkKanaName()
      this.checkPwd()
      this.checkPwd2()
      this.checkEmailAddr()
      this.$refs.form.validate()
      // チェック項目が全て true ならば確認画面に遷移する false があればアラートを表示する
      if (this.userNameIsValid && this.userKanaNameIsValid && this.userPwdIsValid && this.userPwd2IsValid && this.mladdrsIsValid) {
        this.isChange = false
        this.errorFlg = false
      } else {
        this.errorFlg = true
        this.makeErrorMsg()
      }
    },
    submit_update () {
      this.updateDialog = false

      if (this.userNameIsValid && this.userKanaNameIsValid && this.userPwdIsValid && this.userPwd2IsValid && this.mladdrsIsValid) {
        this.isChange = false
        myAxios.post('/api/usr_mstr/user_my_data', this.formData).then(res => {
          if (res.data.status && res.data.result) {
            // popupに表示するユーザ名を更新する
            this.$store.dispatch('appSetting/resaveUserName', this.formData.user_nm)
            this.$router.push('/initial')
          } else {
            alert(MsgList.MSG_FORM_SUBMIT_ERROR)
          }
        // eslint-disable-next-line handle-callback-err
        }).catch(err => {
          alert(MsgList.MSG_FORM_SUBMIT_ERROR)
        })
      }
    }
  },
  computed: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modules/UsrPassChange.vue